import { put, call, takeLatest } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import NoticeHelper from 'helpers/notice'
import UrlHelper from 'helpers/url'
import * as ApiRouter from 'constants/apiRouting'
import { SHOW_NOTICE } from 'reducers/notice'
import {
  FETCH_JOB_INPUT_GROUP_TABLE_DATA,
  FETCH_JOB_INPUT_GROUP_TABLE_DATA_SUCCESS,
  FETCH_JOB_INPUT_GROUP_TABLE_DATA_FAILURE,
  FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM,
  FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_SUCCESS,
  FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_FAILURE,
  SAVE_JOB_INPUT_GROUPS_INFO,
  DELETE_JOB_INPUT_GROUP_ITEM,
} from './reducer'
import { fetchJobInputItemsTable } from '../jobInputItemsAdmin/saga'

function* fetchJobInputGroupsTable({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${
        ApiRouter.JOB_WORKFLOW_INPUT_GROUPS_TABLE
      }${UrlHelper.getPsfsQuery(payload)}`,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_JOB_INPUT_GROUP_TABLE_DATA_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_JOB_INPUT_GROUP_TABLE_DATA_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB INPUT GROUP DATA ERROR', error)
  }
}

function* fetchJobWorkflowInputGroupItem({ payload: { entityId } }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRouter.JOB_WORKFLOW_INPUT_GROUPS_DETAILS, {
        id: entityId,
      }),
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB WORKFLOW INPUT GROUP ITEM', error)
  }
}

function* saveJobInputGroupsInfo({ payload: { entityId, data }, promise }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: entityId
        ? UrlHelper.create(ApiRouter.JOB_WORKFLOW_INPUT_GROUPS_ITEM, {
            id: entityId,
          })
        : ApiRouter.JOB_WORKFLOW_INPUT_GROUPS,
      method: entityId ? 'PUT' : 'POST',
      data,
    })

    if (response.error) {
      yield call(promise.resolve, response.errors)
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(
          'Job Input Group Successfully Saved',
        ),
      })
    }

    yield call(promise.resolve, false)
  } catch (error) {
    console.log('POST PUT JOB INPUT GROUP ERROR ', error)
  }
}

function* deleteJobInputGroupItem(action) {
  const {
    payload: { entityId, entityType },
  } = action

  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRouter.JOB_WORKFLOW_INPUT_GROUPS_ITEM, {
        id: entityId,
      }),
      method: 'DELETE',
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(
          'Job Input Group was successfully deleted',
        ),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'Something went wrong when deleting',
        ),
      })
    }

    if (entityType === 'inputGroup') {
      yield fetchJobInputItemsTable(action)
    } else {
      yield fetchJobInputGroupsTable(action)
    }
  } catch (error) {
    console.log('DELETE JOB INPUT GROUP ERROR', error)
  }
}

function* jobInputGroupAdminSaga() {
  yield takeLatest(FETCH_JOB_INPUT_GROUP_TABLE_DATA, fetchJobInputGroupsTable)
  yield takeLatest(
    FETCH_JOB_WORKFLOW_INPUT_GROUP_ITEM,
    fetchJobWorkflowInputGroupItem,
  )
  yield takeLatest(SAVE_JOB_INPUT_GROUPS_INFO, saveJobInputGroupsInfo)
  yield takeLatest(DELETE_JOB_INPUT_GROUP_ITEM, deleteJobInputGroupItem)
}

export default jobInputGroupAdminSaga
